/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PostProjectsOptions, PostProjectsResponses } from '../types/PostProjects'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/}
 */
export function postProjects<ThrowOnError extends boolean = true>(options: Options<PostProjectsOptions, ThrowOnError>): Unwrappable<RequestResult<PostProjectsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'POST', url: '/projects/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PostProjectsResponses, ThrowOnError>>)
}
